<template>
  <div class="fact c-fluid">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-5">
        <h1 class="quote">did you know?</h1>
        <button
          class="btn-main text-white p-3 my-3 my-md-5"
          @click="scrollToPosition('#action')"
        >T A K E &nbsp; A C T I O N</button>
      </div>
      <div class="col-sm-12 col-md-5">
        <div
          class="fact-box my-4 row justify-content-between"
          v-for="(f, index) in list"
          :key="index"
        >
          <div class="col-9">
            <h2 class="fw-6 mb-0">{{f.title}}</h2>
            <p>{{f.description}}</p>
          </div>
          <div class="col-3 text-right my-auto">
            <div class="mb-4 mx-auto text-center py-2 social-media yellow">
              <a class="twitter-share-button" target="_blank" :href="f.tweet">
                <i class="fab fa-twitter"></i>
              </a>
            </div>
            <!-- <div class="mb-4 mx-auto text-center py-2 social-media yellow">
              <a class="twitter-share-button" target="_blank" :href="f.post">
                <i class="fab fa-facebook-f"></i>
              </a>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "./../data/data";
export default {
  name: "Facts",
  data() {
    return {
      list: data.facts
    };
  },
  methods: {
    scrollToPosition(id) {
      $("html, body").animate(
        {
          scrollTop: $(id).offset().top - 50
        },
        0
      );
    }
  }
};
</script>

<style scoped>
.quote {
  margin: unset !important;
}
.fact {
  background-image: url("/static/imgs/facts.png");
  background-size: cover;
  color: white;
}

@media screen and (max-width: 800px) {
  .fact {
    padding: 4rem 2rem;
  }
}
@media screen and (min-width: 801px) {
  .fact {
    padding: 6rem;
  }
}
.fact-box h2 {
  font-family: "Eczar", serif;
  font-size: 3rem;
}
.fact-box {
  color: black !important;
  background-color: white;
}
@media screen and (max-width: 991px) {
  .fact-box {
    /* height: 180px; */
  }
}
@media screen and (max-width: 400px) {
  .fact-box {
    padding: 1.5rem !important;
  }
}
@media screen and (min-width: 401px) {
  .fact-box {
    padding: 3rem !important;
  }
}
@media screen and (min-width: 992px) {
  .fact-box {
    /* height: 220px; */
  }
}
.social-media {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
@media screen and (max-width: 700px) {
  .stat {
    font-size: 2rem;
  }
}
@media screen and (min-width: 701px) {
  .stat {
    font-size: 4rem;
  }
}

@media screen and (max-width: 1080px) {
  .fact-box h2 {
    font-size: 1.6rem;
  }
}
@media screen and (min-width: 1081px) {
  .fact-box h2 {
    font-size: 2.6rem;
  }
}
a,
a:hover {
  color: unset !important;
  text-decoration: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Facts.vue